import { ReadonlyRecord, IDictionary } from '@bimser/core';
import { Record, Map } from 'immutable';

export interface IBaseIProjectInfo {
	projectId?: string;
	projectName?: string;
	assetFolderId?: string;
	projectUniqueId?: string;
	projectSecretKey?: string;
	passKey?: string;
}

export default interface IProjectInfo extends IBaseIProjectInfo {
	projectCaption?: IDictionary<string>;
}

export interface IReadonlyBaseIProjectInfo extends IBaseIProjectInfo {
	projectCaption?: Map<string, string>;
}

export type ProjectInfo = ReadonlyRecord<IReadonlyBaseIProjectInfo>;

export const ProjectInfoFactory = Record<IReadonlyBaseIProjectInfo>({
	projectId: null,
	projectName: null,
	assetFolderId: null,
	projectCaption: null,
	projectUniqueId: null,
	projectSecretKey: null,
	passKey: null
});

export const ProjectInfoFactoryFromJS = function (data: IProjectInfo) {
	return ProjectInfoFactory({
		...data,
		projectCaption: Map(data.projectCaption)
	});
};
